import React from 'react';
import BudgetAllocationWorkspace from './BudgetAllocationWorkspace';

/** 예산배정처리 */
export default function BudgetAllocProcess() {
  return <BudgetAllocationWorkspace screenMode="process" />;
}
